import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "speaker-detail-dialog"
}
const _hoisted_2 = {
  class: "speaker-detail-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = { class: "speaker-detail-container" }
const _hoisted_5 = { class: "speaker-logo" }
const _hoisted_6 = { class: "speaker-detail-infos" }
const _hoisted_7 = { class: "speaker-name" }
const _hoisted_8 = { class: "speaker-company" }
const _hoisted_9 = { class: "speaker-position" }
const _hoisted_10 = { class: "speaker-infos" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "speaker-speeches" }
const _hoisted_13 = { class: "speech" }
const _hoisted_14 = { class: "speech-header" }
const _hoisted_15 = { class: "speech-category" }
const _hoisted_16 = { class: "speech-date" }
const _hoisted_17 = { class: "speech-content" }
const _hoisted_18 = { class: "speech-title" }
const _hoisted_19 = {
  key: 0,
  class: "speech-speakers-multi"
}
const _hoisted_20 = {
  key: 0,
  class: "speaker-container"
}
const _hoisted_21 = { class: "speaker-list-multi" }
const _hoisted_22 = { class: "speaker-header" }
const _hoisted_23 = ["set"]
const _hoisted_24 = {
  key: 0,
  class: "speaker-name"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "speaker-position"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 2,
  class: "speaker-company"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 3,
  class: "speaker-country"
}
const _hoisted_31 = { class: "speaker-images" }
const _hoisted_32 = ["title"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 2,
  class: "speech-speakers-multi speech-infos-multi"
}
const _hoisted_35 = { class: "speaker-container" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "speaker-images" }
const _hoisted_38 = {
  key: 0,
  class: "speaker-images-role-container"
}
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "speech-footer" }
const _hoisted_41 = { class: "speech-time-container" }
const _hoisted_42 = { class: "speech-place" }
const _hoisted_43 = { class: "speech-language" }
const _hoisted_44 = {
  key: 0,
  class: "speech-translation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, "X")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "speaker-image",
                style: _normalizeStyle([_ctx.speaker.hasPicture() ? {'background-image':'url('+ _ctx.speaker.getPictureUrl()+')'} : {} ])
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.speaker.displayName), 1),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.speaker.company), 1),
              _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.speaker.position), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.speaker.info)
              ? (_openBlock(), _createElementBlock("small", {
                  key: 0,
                  class: "infos",
                  innerHTML: _ctx.speaker.info
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speeches, (speech) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(speech.category), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(speech.startDate), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(speech.title), 1)
                ]),
                (!speech.showInfoInsteadOfSpeakers())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (speech.speakers.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (speech.hasSpeakerWithRole(role))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(speech.getPersonsByRole(role).length > 1 ? role.displayNamePlural : role.displayNameSingular) + ": ", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "speaker",
                                          set: _ctx.speaker=_ctx.getSpeakerById(s.id)
                                        }, [
                                          (_ctx.speaker.displayName)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.displayName), 1),
                                                (_ctx.speaker.position || _ctx.speaker.company || _ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.position)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.position), 1),
                                                (_ctx.speaker.company || _ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.company)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.company), 1),
                                                (_ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.country)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.speaker.country), 1))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_23))
                                      }), 256))
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "image",
                                          title: _ctx.getSpeakerById(s.id).displayName,
                                          style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image':'url('+ _ctx.getSpeakerById(s.id).getPictureUrl()+')'} : {} ])
                                        }, null, 12, _hoisted_32))
                                      }), 256))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!speech.showInfoInsteadOfSpeakers() && speech.info !== undefined && speech.info.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "speech-info",
                      innerHTML: speech.info
                    }, null, 8, _hoisted_33))
                  : _createCommentVNode("", true),
                (speech.showInfoInsteadOfSpeakers())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", {
                          class: "speaker-list-multi",
                          innerHTML: speech.info
                        }, null, 8, _hoisted_36),
                        _createElementVNode("div", _hoisted_37, [
                          (speech.speakers.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (speech.hasSpeakerWithRole(role))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "image",
                                            title: _ctx.getSpeakerById(s.id).displayName,
                                            style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image':'url('+ _ctx.getSpeakerById(s.id).getPictureUrl()+')'} : {} ])
                                          }, null, 12, _hoisted_39))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-clock" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(speech.beginTime) + " - " + _toDisplayString(speech.endTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(speech.place), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-comment-alt-lines" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getLangForSpeechById(speech.languageID)), 1)
                  ]),
                  (speech.hasTranslation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-headphones-alt" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("translate")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256))
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}